import React, { useState, useCallback } from 'react';

import styles from './ContentCanvas.scss';
import ContentTitleCard from 'Components/ContentTitleCard';
import GamePlayer from 'Components/GamePlayer';
import { PreContentAd } from '../../utils/Playwire/PreContentAd';

import { useDetectAdBlock } from "adblock-detect-react";


const ContentCanvas = props => {
  const { showTitleCard, type, showPreContentAd } = props;
  const adBlockDetected = useDetectAdBlock();

  const [precontentAdIsVisibile, setPrecontentAdVisibility] = useState(
    showPreContentAd
  );
  
  // Callback for PreContentAd
  const onAdComplete = useCallback(() => {
    setPrecontentAdVisibility(false);
  }, []);

  // When the title card is visible, we need to set a fixed aspect ratio.
  const titleCardVisible =
    showTitleCard && !props.gameStarted && !precontentAdIsVisibile;

  const canvasContents =
    !props.gameStarted && showTitleCard ? (
      <ContentTitleCard
        backgroundImageURL={props.imageURI}
        onStartGame={props.onStartGame}
        mediaType={props.contentType}
      />
    ) : (
      <GamePlayer {...props} additionalClasses={` GamePlayer--${type}`} />
    );

  const style = {};
  if (props.maxWidth) style.maxWidth = props.maxWidth;

  return (
    <div
      className={`ContentCanvas${titleCardVisible ? ' has-visible-title-card' : ''}`}
      style={style}
    >
      {!precontentAdIsVisibile || adBlockDetected ? (
        canvasContents
      ) : (
        <PreContentAd type='precontent_ad_video' onAdComplete={onAdComplete}>
          {showTitleCard && canvasContents}
        </PreContentAd>
      )}
    </div>
  );
};

export default ContentCanvas;
